import { GROUP_ITEM_WASHED_PER_HOUR_FAILURE, GROUP_ITEM_WASHED_PER_HOUR_SUCCESS } from 'redux/constants/MTag';
import { onFailure, onSuccess } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
    switch (action.type) {
        case GROUP_ITEM_WASHED_PER_HOUR_SUCCESS:
            return onSuccess(state, action);
        case GROUP_ITEM_WASHED_PER_HOUR_FAILURE:
            return onFailure(state, action);
        default:
            return { ...state };
    }
};
